module.exports = __webpack_public_path__ + "static/media/connor.353d56cd.jpg";